import Cookies from 'js-cookie';

var CmvBidBarrel = /*#__PURE__*/function () {
  function CmvBidBarrel(config) {
    this.adCountByType = {};
    this.config = config;
    this.debug = config.debug;
    this.useAlt = config.useAlt;
    this.mapToAdUnits = config.mapToAdUnits;
    this.unitSize = this.getUnitSize();
    var ads = this.getAds();
    this.adElements = ads.adElements;
    this.availableAds = ads.availableAds;
    this.logMessage('Created');
  }

  var _proto = CmvBidBarrel.prototype;

  _proto.getUnitSize = function getUnitSize() {
    var unitSize = 'desktop';

    if (this.isMobile()) {
      unitSize = 'mobile';
    } else {
      var browserWidth = window.innerWidth;

      if (browserWidth < this.config.mobileBreak) {
        unitSize = 'mobile';
      } else {
        unitSize = 'desktop';
      }
    }

    return unitSize;
  };

  _proto.isMobile = function isMobile() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
      return true;
    }

    return false;
  };

  _proto.getAds = function getAds() {
    var _this = this;

    var adElements = [];
    var availableAds = [];
    this.mapToAdUnits[this.unitSize].forEach(function (item) {
      var elements = document.querySelectorAll("[data-ad-ref=\"" + item + "\"]");
      var isIncremental = elements[0] && elements[0].dataset ? !!elements[0].dataset.incremental : false;

      if (!!elements) {
        adElements.push.apply(adElements, document.querySelectorAll("[data-ad-ref=\"" + item + "\"]"));

        if (isIncremental) {
          elements.forEach(function (elem) {
            availableAds.push([item, elem.dataset.incremental, {
              pos: 'inc'
            }, {
              cache: true
            }]);
            _this.adCountByType[item] = _this.adCountByType.hasOwnProperty(item) ? _this.adCountByType[item] + 1 : 1;
          });
        } else {
          availableAds.push(item);
          _this.adCountByType[item] = _this.adCountByType.hasOwnProperty(item) ? _this.adCountByType[item] + 1 : 1;
        }
      }
    });
    return {
      adElements: adElements,
      availableAds: availableAds
    };
  };

  _proto.getAdUnitByRef = function getAdUnitByRef(ref) {
    var match = this.mapToAdUnits[this.unitSize].find(function (elem) {
      return elem === ref;
    });
    return match || null;
  };

  _proto.injectBidBarrelScript = function injectBidBarrelScript() {
    if (this.config.scriptUrl) {
      var scriptNode = document.getElementById('bb-cbsoptanon');
      var insertNode = {};
      var bb = document.createElement('script');

      if (scriptNode) {
        insertNode = scriptNode.nextSibling;
      } else {
        scriptNode = document.getElementsByTagName('script')[0];
        insertNode = scriptNode;
      }

      bb.async = true;
      bb.type = 'text/javascript';
      bb.id = 'bb-lib';
      bb.src = this.config.scriptUrl;
      scriptNode.parentNode.insertBefore(bb, insertNode);
    }
  };

  _proto.attachEvents = function attachEvents() {
    BidBarrel.on('identified', function (adIdentity, unitConfig, gptRenderedEventObj) {
      if (adIdentity.code === 'omni-skybox-plus-sticky' || adIdentity.code === 'mobile-omni-skybox-plus-sticky') {
        this.logMessage("[Sticky Banner Ad] adIdentity.type: " + adIdentity.type + ". adIdentity.size:", adIdentity.size);
        var adSize = Array.isArray(adIdentity.size) ? "size-" + adIdentity.size.join('x') : '';

        if (adIdentity.type === 'display' && adSize !== 'size-5x5' && adSize !== 'size-6x6') {
          var isMobile = adIdentity.code.includes('mobile-');

          if (isMobile) {
            this.config.toggleSticky("display stick-bottom " + adSize, 0, adIdentity.type);
          } else {
            var offset = this.config.noDisplayAdOffset ? null : parseInt(adIdentity.size[1] + 24, 10);
            this.config.toggleSticky("display stick " + adSize, offset, adIdentity.type);
          }

          this.logMessage('Sticky Banner Active');
        } else {
          this.config.toggleSticky(adIdentity.type + " " + adSize, null, adIdentity.type);
        }
      }
    }.bind(this));
    this.logMessage('Events Attached');
  };

  _proto.initializeBidBarrel = function initializeBidBarrel() {
    var config = {
      dfpPath: this.createDfpPath(),
      pageTargeting: this.getPageTargeting(),
      targeting: {
        auto: true,
        cookie: {
          consolidate: true
        }
      },
      lazyLoading: this.getLazyLoading()
    };

    if (!window.didBidBarrelInit) {
      if (!window.BidBarrel) {
        (function (a) {
          var w = window,
              b = 'BidBarrel',
              q = 'queue';
          w[b] = w[b] ? w[b] : {};
          w[b][q] = w[b][q] ? w[b][q] : [];
          a.forEach(function (z) {
            w[b][z] = w[b][z] || function () {
              var c = arguments;
              w[b][q].push(function (r) {
                w[b][z].apply(w[b], c);
                r();
              });
            };
          });
        })(['refresh', 'auction', 'initialize', 'setTargeting', 'setSizeMappings', 'setLazyLoad', 'clearSlots', 'resetAllTargeting', 'setConfig', 'on']);
      }

      BidBarrel.initialize(config);
      window.didBidBarrelInit = true;
      this.attachEvents();
      this.logMessage('Bid Barrel Initialized');
    } else {
      BidBarrel.setConfig(config);
      this.logMessage('Bid Barrel Set Config');
    }
  };

  _proto.init = function init() {
    if (typeof window.BidBarrel === 'undefined') {
      this.injectBidBarrelScript();
    }

    this.initializeBidBarrel();
    this.updateAdElementAttributes();
  };

  _proto.createDfpPath = function createDfpPath() {
    return '/' + this.config.networkId + '/' + (this.unitSize === 'mobile' ? this.config.mobileAdUnitSizePrefix : this.config.adUnitSizePrefix) + '/' + this.config.page_targeting.ad_unit_path_suffix.replace(/ /g, '_');
  };

  _proto.getPageTargeting = function getPageTargeting() {
    var pageTargeting = {};

    if (this.config.page_targeting.nid) {
      pageTargeting.node = this.config.page_targeting.nid;
    }

    if (this.config.page_targeting.keywords) {
      pageTargeting.kw = this.config.page_targeting.keywords;
    }

    if (this.config.page_targeting.category) {
      pageTargeting.section = this.config.page_targeting.category;
    }

    if (this.config.page_targeting.categories) {
      pageTargeting.category = this.config.page_targeting.categories;
    }

    if (this.config.page_targeting.ad_page_type) {
      pageTargeting.ptype = this.config.page_targeting.ad_page_type;
    }

    if (this.config.page_targeting.ftag) {
      pageTargeting.ftag = this.config.page_targeting.ftag;
    }

    if (this.config.page_targeting.vguid) {
      pageTargeting.vguid = this.config.page_targeting.vguid;
    }

    if (this.config.page_targeting.env) {
      pageTargeting.env = this.config.page_targeting.env;
    }

    pageTargeting.pv = this.addPageView();
    return pageTargeting;
  };

  _proto.addPageView = function addPageView() {
    var cookieName = 'pv';
    var pageView = parseInt(Cookies.get(cookieName));
    pageView = isNaN(pageView) ? 1 : pageView + 1;
    var midnightTonight = new Date();
    midnightTonight.setDate(midnightTonight.getDate() + 1);
    midnightTonight.setHours(0, 0, 0, 0);
    Cookies.set(cookieName, pageView, {
      path: '/',
      expires: midnightTonight
    });
    return pageView;
  };

  _proto.getLazyLoading = function getLazyLoading() {
    var lazyLoading = {};
    var isLazyLoad = typeof this.config.lazyLoadAuction !== 'undefined' && this.config.lazyLoadAuction === false ? false : true;

    if (isLazyLoad) {
      lazyLoading = {
        auction: {
          enabled: true,
          lazy: true
        }
      };
    }

    return lazyLoading;
  };

  _proto.updateAdElementAttributes = function updateAdElementAttributes() {
    var _this2 = this;

    this.adElements.forEach(function (el) {
      var ref = el.getAttribute('data-ad-ref');

      var unit = _this2.getAdUnitByRef(ref);

      if (unit) {
        el.classList.add(unit);
        var incremental = el.getAttribute('data-incremental');

        if (incremental) {
          unit += incremental;
        }

        el.setAttribute('id', unit);
      } else {
        _this2.logError('Ad element update failed.', [ref, _this2.unitSize]);
      }
    });
  };

  _proto.auction = function auction() {
    if (window.BidBarrel) {
      window.BidBarrel.auction(this.availableAds);
      this.logMessage('Starting Auction', this.availableAds);
    }
  };

  _proto.auctionNewAds = function auctionNewAds(adUnits) {
    var _this3 = this;

    if (!window.BidBarrel) {
      return;
    }

    adUnits[this.unitSize].forEach(function (adType) {
      var elements = document.querySelectorAll("[data-ad-ref=\"" + adType + "\"]");
      var offset = _this3.adCountByType.hasOwnProperty(adType) ? _this3.adCountByType[adType] : 0;
      var newAds = Array.from(elements).slice(offset).map(function (el, index) {
        el.classList.add(adType);
        var incremental = el.getAttribute('data-incremental') || '';
        el.setAttribute('id', "" + adType + incremental);

        _this3.adElements.push(el);

        if (incremental) {
          return [adType, (index + offset).toString(), {
            pos: 'inc'
          }, {
            cache: true
          }];
        }

        return adType;
      });
      _this3.adCountByType[adType] = _this3.adCountByType.hasOwnProperty(adType) ? _this3.adCountByType[adType] + newAds.length : newAds.length;
      _this3.availableAds = _this3.availableAds.concat(newAds);
      window.BidBarrel.auction(newAds);

      _this3.logMessage('Starting Auction For New Ads', newAds);
    });
  };

  _proto.clearSlots = function clearSlots() {
    if (window.BidBarrel) {
      window.BidBarrel.clearSlots(this.availableAds);
      this.logMessage('Clearing Slots', this.availableAds);
    }
  };

  _proto.destroySlots = function destroySlots() {
    if (window.BidBarrel) {
      window.BidBarrel.destroySlots(this.availableAds);
      this.logMessage('Destroying Slots', this.availableAds);
    }
  };

  _proto.resetAllTargeting = function resetAllTargeting() {
    if (window.BidBarrel) {
      window.BidBarrel.resetAllTargeting();
      this.logMessage('Resetting All Targeting');
    }
  };

  _proto.logError = function logError(message, errors) {
    if (this.debug) {
      console.error(message, errors);
    }
  };

  _proto.logMessage = function logMessage(msg) {
    var debug = localStorage.getItem('cmvBidBarrelDebug');

    if (debug) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      console.log('%cCMV Bid Barrel', 'background: #b4d455; color: #000; border-radius: 2px; padding: 2px;', msg, rest.length ? rest : '');
    }
  };

  return CmvBidBarrel;
}();

export default CmvBidBarrel;
//# sourceMappingURL=index.modern.js.map
